var _rect, _path, _path2, _line, _line2, _line3, _line4, _line5, _text, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0D47A1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1565C0",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dnaGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4FC3F7",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#29B6F6",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 480,
    height: 480,
    rx: 80,
    ry: 80,
    fill: "url(#bgGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 100 Q220 160 180 220 Q140 280 180 340 Q220 400 180 420",
    stroke: "url(#dnaGrad)",
    strokeWidth: 14,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240 100 Q200 160 240 220 Q280 280 240 340 Q200 400 240 420",
    stroke: "#81D4FA",
    strokeWidth: 14,
    fill: "none",
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 140,
    x2: 232,
    y2: 140,
    stroke: "#B3E5FC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 190,
    x2: 248,
    y2: 190,
    stroke: "#B3E5FC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 250,
    x2: 232,
    y2: 250,
    stroke: "#B3E5FC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 310,
    x2: 248,
    y2: 310,
    stroke: "#B3E5FC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 370,
    x2: 232,
    y2: 370,
    stroke: "#B3E5FC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 310,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "bold",
    fontSize: 200,
    fill: "white",
    textAnchor: "middle",
    dominantBaseline: "central",
    opacity: 0.95
  }, "Z")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 440 L160 440 L190 410 L220 470 L250 420 L270 440 L432 440",
    stroke: "#4FC3F7",
    strokeWidth: 8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3d3020e8e5aea902484388681947fb3.svg";
export { ForwardRef as ReactComponent };